export default __webpack_public_path__ + "static/media/Gabriele Lanzafame.f733673f.jpg";